import darkCoverImage from 'img/aside-promo-modal/cloud-dark.jpg';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { EAsidePromoModalTheme } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.types';
import { sendGa } from 'reactApp/utils/ga';

export const showCloneAsideModal = (id: string, storage: EStorageType, bottom?: number) => {
    if (!id) {
        return;
    }

    openAsidePromoModal({
        title: 'Храните в Облаке',
        text: 'Файл не будет занимать место на устройстве, а бесплатных гигабайтов хватит на сотни фото и видео',
        buttonText: 'Сохранить в Облако',
        imageUrl: darkCoverImage,
        theme: EAsidePromoModalTheme.dark,
        bottom,
        onClick: () => {
            toolbarActions.clone({
                id,
                storage,
                destination: '',
                source: 'attaches-viewer',
            });

            sendGa('clck-aside-mdl', 'ab-save');
        },
        onShow: () => sendGa('shw-aside-mdl', 'ab-save'),
        onClose: () => sendGa('cls-aside-mdl', 'ab-save'),
    });
};
